import axios from 'axios'
import { useAxios } from 'common/hooks/useApi'
import { NetType } from 'config/types/controllerConfig'
import { ChargePointSetupRow, ChargePointSetupStatus } from 'electricianView/types/chargePointSetup'

interface PostChargePointSetupParams {
    parkingSpot: string
    smsCode: string
    serialNumber: string
    netType: NetType
    phaseMapping: string
    description: string
    networkLocation: string
    status: ChargePointSetupStatus
    cluster: string
}

export default function usePostChargePointSetup(controllerId: string, accessToken?: string) {
    const getAuthenticatedAxiosInstance = useAxios()

    return async (params: PostChargePointSetupParams) => {
        const axiosClient = accessToken
            ? axios.create({ baseURL: process.env.REACT_APP_BACKEND_API_URL })
            : await getAuthenticatedAxiosInstance()

        const path =
            `/api/charge-point-setup/${controllerId}` + (accessToken ? `/${accessToken}` : '')
        return axiosClient
            .post(path, null, { params })
            .then((res) => res.data as ChargePointSetupRow)
    }
}
